import { INTERSTITIAL_AD_CONFIG, INTERSTITIAL_AD_EVENTS } from '@/app/constants';
import { reportEvent } from '@/app/utils';

declare global {
  interface Window {
    __viduInterstitialSlot?: googletag.Slot;
  }
}

/**
 * GPT 加载完成后调用：尽早定义插页 slot 并 display() 请求广告
 * 这样用户第一次点击锚点时广告已就绪，能正常展示
 * 如果想要广告展示，必须通过点击锚标记元素
 * 参考文档：https://developers.google.com/publisher-tag/samples/display-web-interstitial-ad?hl=zh-cn
 */
export function initInterstitialSlot(): void {
  if (typeof window === 'undefined' || !window.googletag) return;

  window.googletag.cmd.push(() => {
    if (window.__viduInterstitialSlot) return;

    const slot = window.googletag.defineOutOfPageSlot(
      INTERSTITIAL_AD_CONFIG.AD_UNIT_PATH,
      window.googletag.enums.OutOfPageFormat.INTERSTITIAL,
    );

    if (slot) {
      slot.addService(window.googletag.pubads()).setConfig({
        interstitial: {
          triggers: {
            navBar: false,
            unhideWindow: false,
          },
          requireStorageAccess: true,
        },
      });
      window.__viduInterstitialSlot = slot;

      // 监听插页可见性变化：用户点击关闭时，插页从可见变为不可见
      const handleVisibilityChanged = (event: googletag.events.SlotVisibilityChangedEvent) => {
        if (event.inViewPercentage === 0) {
          reportEvent('interstitial_ad_finish_click', { from_page: 'download' });
        }
      };
      window.googletag
        .pubads()
        .addEventListener(INTERSTITIAL_AD_EVENTS.SLOT_VISIBILITY_CHANGED, handleVisibilityChanged);
    }

    window.googletag.pubads().enableSingleRequest();
    window.googletag.enableServices();

    if (window.__viduInterstitialSlot) {
      window.googletag.display(window.__viduInterstitialSlot);
    }
  });
}
